import api from '../api'

export default {
    namespaced: true,
    state: {
        date: null,
        amount: 0,
        intoRecordList: {// 投入记录
            beanList: [],
            total: 0
        },
        commissionRecordList: {// 战绩流水返佣记录
            
            beanList: [],
            total: 0
        },
        waitingRebateRecordList: {//待手动返佣记录
            beanList: [],
            total: 0
        },
    },
    getters: {
        date_start: state => {
            return state.date && state.date[0] || ''
        },
        date_end: state => {
            return state.date && state.date[1] || ''
        }
    },
    mutations: {
        setStateDate(state, info) {
            state.date = info;
        },
        setStateIntoRecordList(state, info) {
            state.amount = info.amount;
            state.intoRecordList = info.intoRecords;
        },
        setStateCommissionRecordList(state, info) {
            state.commissionRecordList = info
        },
        setStateWaitingRebateRecordList(state, info) {
            state.waitingRebateRecordList = info
        }
    },
    actions: {
        getIntoRecordList({getters, commit}, page) {
            let params = {
                page: page,
                size: 20,
                startTime: getters.date_start,
                endTime: getters.date_end
            };
            return api.post('/jpb/account/into/record/list', 'jpb仓投彩记录', params).then(res => {
                commit('setStateIntoRecordList', res.data)
            })
        },
        getCommissionRecordList({getters, commit}, page) {
            let params = {
                page: page,
                size: 20,
                startTime: getters.date_start,
                endTime: getters.date_end
            };
            return api.post('/jpb/account/list', '战绩流水返佣记录', params).then(res => {
                commit('setStateCommissionRecordList', res.data)
            })
        },
        getWaitingRebateRecordList({getters, commit}, page) {
            let params = {
                page: page,
                size: 20,
                startTime: getters.date_start,
                endTime: getters.date_end
            };
            return api.post('/jpb/account/manual/list', '战绩流水手动返佣记录', params).then(res => {
                commit('setStateWaitingRebateRecordList', res.data)
            })
        }
    }
}